import { render, staticRenderFns } from "./FoodSafetyAnalysis.vue?vue&type=template&id=ddac8c9c&scoped=true"
import script from "./FoodSafetyAnalysis.vue?vue&type=script&lang=js"
export * from "./FoodSafetyAnalysis.vue?vue&type=script&lang=js"
import style0 from "./FoodSafetyAnalysis.vue?vue&type=style&index=0&id=ddac8c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddac8c9c",
  null
  
)

export default component.exports